import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import axios from 'axios';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import MobileBottomNav from './components/MobileBottomNav';
import FloatingAIAssistant from './components/FloatingAIAssistant';

// Fasal Drishti 8 Core Screens
import Landing from './pages/Landing';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CheckRisk from './pages/CheckRisk';
import RiskResult from './pages/RiskResult';
import Interventions from './pages/Interventions';
import HistoryTracking from './pages/HistoryTracking';
import FarmerProfile from './pages/FarmerProfile';
import Market from './pages/Market';
import Admin from './pages/Admin';
import SuperAdmin from './pages/SuperAdmin';
import AppLayout from './components/AppLayout';
import ProtectedRoute from './components/ProtectedRoute';

import './App.css';

function App() {
  const [farmerProfile, setFarmerProfile] = useState({
    name: 'Sanket Bhende',
    name_hi: 'संकेत भेंडे',
    name_mr: 'संकेत भेंडे',
    location: 'Jalgaon, Maharashtra',
    location_hi: 'जलगांव, महाराष्ट्र',
    location_mr: 'जळगाव, महाराष्ट्र',
    land_size: '5 Acres',
    main_crop: 'Banana'
  });

  const [weatherTelemetry, setWeatherTelemetry] = useState({
    temp: 30.5,
    condition: 'Partly Cloudy',
    condition_hi: 'हल्के बादल',
    condition_mr: 'अंशतः ढगाळ',
    humidity: 46
  });

  // Initialize Dark / Light theme from localStorage
  useEffect(() => {
    const savedTheme = localStorage.getItem('fd_theme');
    if (savedTheme === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
      document.body.classList.add('dark-mode');
    } else {
      document.documentElement.removeAttribute('data-theme');
      document.body.classList.remove('dark-mode');
    }
  }, []);

  // Auto-Detect Location on 1st Page Visit
  useEffect(() => {
    const detectInitialLocation = async () => {
      const savedLocation = localStorage.getItem('farmer_location');
      if (savedLocation) {
        setFarmerProfile(prev => ({ ...prev, location: savedLocation }));
      }

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (pos) => {
            const lat = pos.coords.latitude;
            const lon = pos.coords.longitude;
            try {
              const res = await axios.get(`http://localhost:8000/api/auto-field-telemetry?lat=${lat}&lon=${lon}`);
              const d = res.data;
              setFarmerProfile(prev => ({
                ...prev,
                location: d.location.formatted_address,
                location_hi: d.location.formatted_address,
                location_mr: d.location.formatted_address
              }));
              setWeatherTelemetry({
                temp: d.weather_telemetry.temperature_celsius,
                condition: d.weather_telemetry.condition,
                humidity: d.weather_telemetry.humidity_pct
              });
              localStorage.setItem('farmer_location', d.location.formatted_address);
            } catch (err) {
              console.warn('Auto location fetch fallback:', err);
            }
          },
          async (err) => {
            console.log('Using default Jalgaon coordinates on initial load');
            try {
              const res = await axios.get(`http://localhost:8000/api/auto-field-telemetry?district=Jalgaon`);
              const d = res.data;
              setFarmerProfile(prev => ({ ...prev, location: d.location.formatted_address }));
              setWeatherTelemetry({
                temp: d.weather_telemetry.temperature_celsius,
                condition: d.weather_telemetry.condition,
                humidity: d.weather_telemetry.humidity_pct
              });
            } catch (e) {}
          },
          { enableHighAccuracy: true, timeout: 6000 }
        );
      }
    };

    detectInitialLocation();
  }, []);

  return (
    <Router>
      <div className="App">
        {/* Universal Responsive Navbar with dynamic location */}
        <Navbar farmerProfile={farmerProfile} weatherTelemetry={weatherTelemetry} />

        {/* Main Routes */}
        <main className="content-area">
          <Routes>
            {/* Public Standalone Pages */}
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/super-admin" element={<SuperAdmin />} />

            {/* Protected Routes (Requires Login) */}
            <Route element={<ProtectedRoute />}>
              <Route element={<AppLayout />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/check-risk" element={<CheckRisk />} />
                <Route path="/risk-result" element={<RiskResult />} />
                <Route path="/interventions" element={<Interventions />} />
                <Route path="/advisory" element={<Interventions />} />
                <Route path="/schemes" element={<Interventions />} />
                <Route path="/support" element={<Interventions />} />
                <Route path="/market" element={<Market />} />
                <Route path="/weather" element={<Dashboard />} />
                <Route path="/history" element={<HistoryTracking />} />
                <Route path="/profile" element={<FarmerProfile />} />
                <Route path="/settings" element={<FarmerProfile />} />
              </Route>
            </Route>
          </Routes>
        </main>

        {/* Global Floating AI Assistant ("Ask Fasal Drishti") */}
        <FloatingAIAssistant />

        {/* Mobile Persistent Bottom Navigation */}
        <MobileBottomNav />

        {/* Universal Footer */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
